const globalStyleId = 'gs-text-main';
const defaultSelector = {
  selector: '#{mID} .gf_article-date',
};
export default {
  defaultClass: 'gf_gs-text-paragraph-2',
  settingGroups: {
    [globalStyleId]: {
      'font-size': {
        ...defaultSelector,
        inherit: 'text.fontSize',
        cssAttr: 'font-size',
        listUnit: 'px',
      },
      'line-height': {
        ...defaultSelector,
        inherit: 'text.lineHeight',
        cssAttr: 'line-height',
        listUnit: 'em',
      },
      // "color": {
      //   ...defaultSelector,
      //   inherit: "text.fontColor",
      //   cssAttr: "color"
      // },
      font: {
        ...defaultSelector,
        inherit: 'text.fontFamily',
        cssAttr: 'font-family',
      },
    },
  },
};

export const ARTICLE_DATE_SETTING = [
  {
    gsId: globalStyleId,
    gsSettingGroup: 'Typography',
    isRenderColumn: true,
    prefix: 'gf_gs-text-',
    typeSetting: 'paragraph',
  },
];
